import React from 'react';
import B from 'bem-cn';

import './index.scss';

const cl = B('Typing');

const CHANGE_ROW_TIMEOUT = 300;

export default class Typing extends React.Component {
  static propTypes = {
    typingSpeed: React.PropTypes.number,
    onRowChange: React.PropTypes.func,
    onStartNewRow: React.PropTypes.func,
    onShowNewChar: React.PropTypes.func,
    text: React.PropTypes.array
  };

  static defaultProps = {
    typingSpeed: 100,
    text: []
  };

  constructor(props) {
    super(props);
    this.state = {
      groupIdx: 0,
      rowIdx: 0,
      charIdx: -1
    };
    this.updateTyping = this.updateTyping.bind(this);
  }

  componentDidMount() {
    this.updateTyping();

    this.props.onStartNewRow(this.getTextByGroupRow());
  }

  getTextByGroupRow = (
    replaceStars = true,
    groupIdx = this.state.groupIdx,
    rowIdx = this.state.rowIdx
  ) => {
    const text = this.props.text[groupIdx].items[rowIdx];
    if (replaceStars) {
      return text.replace(/\*\*/g, '');
    }
    return text;
  };

  updateTyping() {
    const currentText = this.getTextByGroupRow();
    if (this.state.charIdx + 1 < currentText.length) {
      const typingSpeedTm = currentText[this.state.charIdx + 1] !== ' '
        ? this.props.typingSpeed
        : 0;

      this.setState(
        {
          charIdx: this.state.charIdx + 1
        },
        () => {
          this.props.onShowNewChar();
          setTimeout(() => this.updateTyping(), typingSpeedTm);
        }
      );
    } else {
      let { groupIdx, rowIdx } = this.state;

      if (groupIdx + 1 < this.props.text.length) {
        groupIdx = groupIdx + 1;
      } else {
        groupIdx = 0;
        rowIdx = rowIdx + 1 < this.props.text[groupIdx].items.length
          ? rowIdx + 1
          : 0;
      }
      // const nextRow = this.state.rowIdx + 1 < this.props.text.length
      //   ? this.state.rowIdx + 1
      //   : 0;
      setTimeout(
        () => {
          if (this.props.onRowChange) {
            this.props.onRowChange();
          }
          // Get next text
          this.props.onStartNewRow(
            this.getTextByGroupRow(true, groupIdx, rowIdx)
          );

          setTimeout(
            () => {
              this.setState(
                {
                  groupIdx,
                  rowIdx,
                  charIdx: -1
                },
                () => {
                  this.updateTyping();
                }
              );
            },
            CHANGE_ROW_TIMEOUT * 2
          );
        },
        CHANGE_ROW_TIMEOUT
      );
    }
  }

  getText() {
    let currentText = this.getTextByGroupRow(false);
    if (currentText) {
      const match = currentText.match(/\*\*([-\/\w\s’`'"]+)\*\*/); // match **sometext**
      currentText = currentText.replace(/\*\*/g, '');

      let ret = [], subRet = [], minColorIndex = -1, maxColorIndex = -1;

      if (match) {
        minColorIndex = match.index;
        maxColorIndex = match.index + match[1].length;
      }

      for (let i = 0; i < currentText.length; i++) {
        let letter = currentText[i];
        if (letter !== ' ' && currentText[i - 1] === ' ') {
          letter = letter.toUpperCase();
        }
        if (letter === ' ') {
          ret.push(subRet);
          subRet = [];
        }
        subRet.push(
          <span
            key={i}
            className={cl('letter', {
              hidden: i > this.state.charIdx,
              space: letter === ' ',
              color: i >= minColorIndex && i <= maxColorIndex
                ? this.props.text[this.state.groupIdx].type
                : false
            })}
          >
            {letter}
          </span>
        );
      }
      ret.push(subRet);
      return ret;
    }
    return '';
  }

  render() {
    const text = this.getText();
    return (
      <span>
        {text.map((word, indexWord) => <span key={indexWord}>{word}</span>)}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/typing/index.js